import { LuUser } from 'react-icons/lu';
import { WsColors } from 'wisestep-base';

import RecruiterAutoCompleteSuggestions from '../components/RecruiterAutoCompleteSuggestions';
import { FilterSetValueProps } from '../models';

import WsAccordion from './WsAccordion';
const RecruiterAutoCompleteInputFilter = ({
  name,
  title,
  showAccordionIcon = false,
}: FilterSetValueProps) => (
  <WsAccordion
    title={title ?? 'Posted By Recruiter'}
    {...(showAccordionIcon && { startIcon: <LuUser color={WsColors.TertiaryShades800} /> })}
  >
    <RecruiterAutoCompleteSuggestions name={name} multiple={true} />
  </WsAccordion>
);

export default RecruiterAutoCompleteInputFilter;
